"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useStudioLiteContext = require("./useStudioLiteContext");
Object.keys(_useStudioLiteContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useStudioLiteContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useStudioLiteContext[key];
    }
  });
});